"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Link = /*#__PURE__*/function () {
  function Link(registry) {
    (0, _classCallCheck2["default"])(this, Link);
    this._api = registry;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Link, [{
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId, fieldMask) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GetLink({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, _marshaler["default"].selectorToFieldMask(fieldMask));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, data) {
        var mask,
            result,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mask = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : _marshaler["default"].fieldMaskFromPatch(data);
                _context2.next = 3;
                return this._api.SetLink({
                  routeParams: {
                    'application_ids.application_id': appId
                  }
                }, {
                  link: data,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function set(_x3, _x4) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.DeleteLink({
                  routeParams: {
                    application_id: appId
                  }
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "getStats",
    value: function () {
      var _getStats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId) {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.GetLinkStats({
                  routeParams: {
                    application_id: appId
                  }
                });

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getStats(_x6) {
        return _getStats.apply(this, arguments);
      }

      return getStats;
    }()
  }]);
  return Link;
}();

var _default = Link;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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